export default __webpack_public_path__ + "static/media/edit-dark.4acd15c0.svg";